import React, { Suspense } from 'react'
import { routes } from './config/routes'
import { Routes, Route } from 'react-router-dom'

const Home = React.lazy(() => import('./screens/Home'))
const Account = React.lazy(() => import('./screens/Account'))
const ScreenConfig = React.lazy(() => import('./screens/Screens/ScreenConfig'))
const MyScreens = React.lazy(() => import('./screens/Screens/MyScreens'))

const AssociateScreen = React.lazy(() => import('./screens/AssociateScreen'))
const Help = React.lazy(() => import('./screens/Help'))
const Privacy = React.lazy(() => import('./screens/Privacy'))

const FlowsList = React.lazy(() => import('./screens/Flows/FlowsList'))
const FlowForm = React.lazy(() => import('./screens/Flows/FlowForm'))
const DesignSystem = React.lazy(() => import('./screens/DesignSystem'))
const NotFound = React.lazy(() => import('./screens/NotFound'))
const Register = React.lazy(() => import('./screens/Register'))

const DataSources = React.lazy(() => import('./screens/DataSources'))
const Members = React.lazy(() => import('./screens/Members'))
const GraphicChart = React.lazy(() => import('./screens/GraphicChart'))
const LegalMentions = React.lazy(() => import('./screens/LegalMentions'))
const Registered = React.lazy(() => import('./screens/Registered'))
const Invitations = React.lazy(() => import('./screens/Invitations'))
const Installation = React.lazy(() => import('./screens/Installation'))
const MediaLibrary = React.lazy(() => import('./screens/MediaLibrary'))

const Subscription = React.lazy(() => import('./screens/Account/Subscription'))

const AdminHelp = React.lazy(() => import('./screens/Admin/AdminHelp'))
const AdminDashboard = React.lazy(() =>
  import('./screens/Admin/AdminDashboard')
)
const Templates = React.lazy(() => import('./screens/Admin/Templates'))
const Companies = React.lazy(() => import('./screens/Admin/Companies'))
const Users = React.lazy(() => import('./screens/Admin/Users'))
const User = React.lazy(() => import('./screens/Admin/User'))
const CompanyDetail = React.lazy(() => import('./screens/Admin/CompanyDetail'))
const AddCompany = React.lazy(() => import('./screens/Admin/AddCompany'))
const Networks = React.lazy(() => import('./screens/Admin/Networks'))
const NetworkDetail = React.lazy(() => import('./screens/Admin/NetworkDetail'))
const TemplateForm = React.lazy(() =>
  import('./components/Template/TemplateForm')
)

import Loading from './components/Loading'
import FlowsContainer from './components/Abstract/FlowsContainer'
import { isAuthorized } from './utils/security'
import { admin_user_role } from './config/config'
import { useKeycloak } from '@react-keycloak/web'
import CGU from './screens/CGU'
import Politic from './screens/Politic'
import AdminAbstract from './components/Abstract/AdminAbstract'
import { checkAccess } from './utils/accesses'

const AppRouter = () => {
  const { keycloak } = useKeycloak()

  const renderAdminRoutes = () => {
    if (!isAuthorized(keycloak, [admin_user_role])) return null
    return (
      <Route path='admin'>
        <Route path='templates' element={<Templates />} />
        <Route path='templates/:id' element={<TemplateForm />} />
        <Route path='help' element={<AdminHelp />} />
        <Route path='companies' element={<Companies />} />
        <Route path='companies/:id' element={<CompanyDetail />} />
        <Route path='users' element={<Users />} />
        <Route path='dashboard' element={<AdminDashboard />} />
      </Route>
    )
  }

  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path={routes.home} component={Home}>
          <Route index element={<Home />} />
          <Route path='register' element={<Register />} />
          <Route path='change_offer' element={<Register />} />
          <Route path='registered' element={<Registered />} />
          <Route path='invitations' element={<Invitations />} />
          <Route path='installation' element={<Installation />} />
          <Route path='my-account' element={<Account />} />
          {checkAccess('graphics.modify') ? (
            <Route path='parameters' element={<GraphicChart isAdmin />} />
          ) : null}
          {checkAccess('graphics.modify') ? (
            <Route path='graphic-chart' element={<GraphicChart />} />
          ) : null}
          {checkAccess('companies.modify') ? (
            <Route path='legal-mentions' element={<LegalMentions />} />
          ) : null}
          <Route path='config_screen' element={<ScreenConfig />} />
          <Route path='screens' element={<MyScreens />} />
          <Route path='flows' element={<FlowsContainer />}>
            <Route path='' element={<FlowsList />} />
            <Route path='add' element={<FlowForm />} />
            <Route path=':id' element={<FlowForm />} />
          </Route>
          <Route path='sources' element={<DataSources />} />
          <Route path='media' element={<MediaLibrary />} />
          <Route
            path='members'
            element={
              <AdminAbstract>
                <Members />
              </AdminAbstract>
            }
          />
          <Route path='help' element={<Help />} />
          <Route path='app-privacy' element={<Privacy />} />
          {checkAccess('subscription.modify') ? (
            <Route path='subscription' element={<Subscription />} />
          ) : null}
          <Route path='design-system' element={<DesignSystem />} />
          <Route
            path='companies'
            element={
              <AdminAbstract>
                <Companies />
              </AdminAbstract>
            }
          />
          <Route
            path='companies/:id'
            element={
              <AdminAbstract>
                <CompanyDetail />
              </AdminAbstract>
            }
          />

          <Route path='networks' element={<Networks />} />
          <Route path='networks/:id' element={<NetworkDetail />} />

          <Route
            path='add-company'
            element={
              <AdminAbstract>
                <AddCompany />
              </AdminAbstract>
            }
          />
          <Route
            path='users'
            element={
              <AdminAbstract>
                <Users />
              </AdminAbstract>
            }
          />
          <Route
            path='user/:id'
            element={
              <AdminAbstract>
                <User />
              </AdminAbstract>
            }
          />

          {/*Other router*/}
          {renderAdminRoutes()}
          {/*No login*/}
          <Route path='loading-TV' element={<p>Prout</p>} />
          <Route path='associate_screen/:uuid' element={<AssociateScreen />} />
          {/*<Route path='test' element={<Test />} />*/}
          <Route path='CGU' element={<CGU />} />
          <Route path='politique_de_confidentialite' element={<Politic />} />
          <Route path='*' element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  )
}

export default AppRouter
